import React from 'react';
import { connect } from 'react-redux';
import Table from '../../common/TableOverView';
import { changeSortState, REDUCER_NAME } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopValueByTicker;

const TableOverViewValue = props => {
  const { listId, isLoading, sortState, changeSortState } = props;

  return (
    <Table
      onSort={changeSortState}
      listId={listId}
      isLoading={isLoading}
      sortState={sortState}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topVolume.overview.overviewTopValueHeader"
    />
  );
};

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopValueTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableOverViewValue);
